/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable max-len */
import sdk from '@/sdk';
import CommonDoc from '@/domains/space/Repository/SidebarNew/CommonDoc';
import {
    RootNodeId,
    sideBarRootNode,
} from '@/domains/space/Repository/SidebarNew/type';
import {
    canSettingKnowledge,
    createHomeUrl,
    createMemberManageUrl,
    createRecycleBinUrl,
    createHomeTagUrl,
    createSettingUrl,
    isPersonalMyself,
} from '@/domains/space/Repository/knowledgeUtils';
import {getIsBaikeRepo} from '@/pages/baike/utils';
import {isPersonal} from '@/domains/space/Repository/Utils/fixRepositoryNameWithPersonal';
import {IntlShape} from 'react-intl';
import {
    HomeSettingSvg,
    HomeRecycleSvg,
    SidebarHomeSvg,
    SidebarDirectorySvg,
    HomeTagSvg,
    SidebarMemberManageSvg,
    SidebarDocSvg,
} from '@/icons';
import * as store from '@/store';
import {MemberCountType} from '@/interface';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';
function getHomeText(repository: Repository) {
    if (getIsBaikeRepo(repository.repositoryGuid)) {
        return 'sidebarNavigation';
    }
    if (isPersonalMyself(repository, sdk.as.user?.userGuid || '')) {
        return 'sidebarMenuMyPersonalHome';
    }
    if (isPersonal(repository)) {
        return 'sidebarMenuPersonalHome';
    }
    return 'sidebarMenuHome';
}

export function getRootNodeListData(
    // 现在根目录的顺序是 主页、成员管理、标签、目录、回收站、设置
    repository: Repository | null,
    tabs: {
        isSetting: boolean;
        isRecycleBin: boolean;
        isMemberManage: boolean;
        docGuid: string | undefined;
        intl: IntlShape;
        isHomeTag: boolean;
        membersCount?: MemberCountType;
    }
) {
    if (!repository) {
        return [] as sideBarRootNode[];
    }
    const {
        isSetting,
        isRecycleBin,
        docGuid,
        intl,
        isMemberManage,
        isHomeTag,
    } = tabs;
    const isMyPersonalRepo = isPersonalMyself(repository, sdk.user?.userGuid!);
    const membersCount = store.getMemberCount();
    const rootNodeList: sideBarRootNode[] = [
        {
            id: RootNodeId.Home,
            icon: SidebarHomeSvg, // TODO后期解决闪烁问题移入插槽 @甄棒
            text: intl.formatMessage({
                id: getHomeText(repository),
            }),
            url: createHomeUrl(repository),
            isSelected: !docGuid && !isRecycleBin && !isSetting && !isHomeTag && !isMemberManage,
            origin: repository,
            visible: true,
        },
        {
            id: RootNodeId.Member,
            icon: SidebarMemberManageSvg,
            text: `${intl.formatMessage({id: 'sidebarMemberManage'})}${
                membersCount?.repoMemberCount ?
                    membersCount && membersCount.repoMemberCount ?
                        (
                            ` (${Number(membersCount.repoMemberCount) > 9999 ? '9999+' : membersCount.repoMemberCount}) `
                        ) : ''
                    : ''
            }`,
            url: createMemberManageUrl(repository),
            isSelected: isMemberManage,
            origin: repository,
            visible: true,
        },
        {
            id: RootNodeId.Setting,
            icon: HomeSettingSvg,
            text: intl.formatMessage({id: 'sidebarMenuSetting'}),
            url: createSettingUrl(repository),
            isSelected: isSetting,
            visible: canSettingKnowledge(repository),
        },
        {
            id: RootNodeId.Tag,
            icon: HomeTagSvg,
            text: getIsBaikeRepo(repository.repositoryGuid) ? // TODO后期解决闪烁问题移入插槽 @甄棒
                intl.formatMessage({id: 'sidebarBaikeMenuTag'}) :
                intl.formatMessage({id: 'sidebarMenuTag'}),
            url: createHomeTagUrl(repository),
            isSelected: isHomeTag,
            visible: true,
        },
        {
            id: RootNodeId.CommonDoc,
            icon: SidebarDocSvg,
            text: intl.formatMessage({id: 'commonDoc'}),
            enableSelected: false,
            contentRender: options => <CommonDoc {...options} />,
            visible: isMyPersonalRepo,
        },
        {
            id: RootNodeId.DocumentIndex,
            icon: SidebarDirectorySvg,
            text: intl.formatMessage({id: 'sidebarMenuDocumentIndex'}),
            enableSelected: false,
            visible: true,
        },
        {
            id: RootNodeId.RecycleBin,
            icon: HomeRecycleSvg,
            text: intl.formatMessage({id: 'sidebarMenuRecycleBin'}),
            url: createRecycleBinUrl(repository),
            isSelected: isRecycleBin,
            visible: canSettingKnowledge(repository),
        },
    ];

    return rootNodeList;
}
